module.exports = __webpack_public_path__ + "img/jazz-festival-footnotes-2023.224aadde.jpeg";